var isArray = require('./isArray'),
    stringToPath = require('./_stringToPath');

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function baseCastPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

module.exports = baseCastPath;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_baseCastPath.js
 ** module id = 281
 ** module chunks = 0
 **/